"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const visa_master_png_1 = __importDefault(require("../../../../static/payments/visa_master.png"));
const applepay_svg_1 = __importDefault(require("../../../../static/payments/applepay.svg"));
const maestro_svg_1 = __importDefault(require("../../../../static/payments/maestro.svg"));
const googlepay_svg_1 = __importDefault(require("../../../../static/payments/googlepay.svg"));
const sepa_svg_1 = __importDefault(require("../../../../static/payments/sepa.svg"));
const fasterpayments_svg_1 = __importDefault(require("../../../../static/payments/fasterpayments.svg"));
const yellowcard_svg_1 = __importDefault(require("../../../../static/payments/yellowcard.svg"));
const pix_png_1 = __importDefault(require("../../../../static/payments/pix.png"));
// https://support.moonpay.com/hc/en-gb/articles/360017624078-What-are-your-supported-payment-methods-
const paymentOptions = [
    { icon: visa_master_png_1.default, id: "visa_master" },
    { icon: maestro_svg_1.default, id: "maestro" },
    { icon: applepay_svg_1.default, id: "apple_pay" },
    { icon: googlepay_svg_1.default, id: "google_pay" },
    { icon: sepa_svg_1.default, id: "sepa" },
    { icon: fasterpayments_svg_1.default, id: "uk_faster_payments" },
    { icon: yellowcard_svg_1.default, id: "yellowcard" },
    { icon: pix_png_1.default, id: "pix" },
];
exports.default = paymentOptions;
//# sourceMappingURL=paymentOptions.js.map